import { render } from "./TemplatesList.vue?vue&type=template&id=3cc09024&ts=true"
import script from "./TemplatesList.vue?vue&type=script&lang=ts"
export * from "./TemplatesList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__